/* src/app/unsubscribe/unsubscribe.component.scss */
.unsubscribe {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 80px;
  width: 791px;
  position: absolute;
  top: 46%;
  left: 48%;
  transform: translate(-50%, -50%);
}
/*# sourceMappingURL=unsubscribe.component-YFUMS7AC.css.map */
